import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const MessageIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M17.917 3.93a.594.594 0 0 1-.137.83l-6.336 4.55a1.585 1.585 0 0 1-1.845.004L3.221 4.762a.593.593 0 1 1 .69-.967l6.378 4.553c.137.098.322.099.461-.001l6.338-4.551a.593.593 0 0 1 .83.136zm1.895 8.552a1.39 1.39 0 0 1-1.387 1.388H2.575a1.39 1.39 0 0 1-1.387-1.388V2.576c0-.765.623-1.387 1.387-1.387h15.85c.764 0 1.387.622 1.387 1.387v9.906zM18.425 0H2.575A2.579 2.579 0 0 0 0 2.576v9.906a2.578 2.578 0 0 0 2.576 2.575h15.85A2.578 2.578 0 0 0 21 12.482V2.576A2.579 2.579 0 0 0 18.425 0z"
    />
  </svg>
);

MessageIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

MessageIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(21, 16),
};

export default MessageIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/message.js